import { apiPost } from '@maestro/core/api-client'

export function warmUpCustomerCache(): Promise<{ success: boolean }> {
  return apiPost<{ success: boolean }>('/api/customer/cache-warmup', {})
}
